/**
 * KlachtBanner — markering dat een item/order een klacht(-herbehandeling) is.
 *
 * Gevoed door `isKlacht` (Werk_Order__r.Klacht_Parent__c gevuld) en `reden`
 * (Klacht_Parent__r.Reden_Klacht__c, semicolon-separated multi-picklist).
 * Wordt door de hele wasserij-keten getoond: voorinspectie, reinigen,
 * na-inspectie. Op de set: WbFlag 'geld' (rood = aandacht, nooit ingeklapt).
 */
import { WbFlag } from './wb';

interface KlachtBannerProps {
  reden?: string | null;
  className?: string;
}

export function KlachtBanner({ reden, className }: KlachtBannerProps) {
  const redenen = (reden ?? '')
    .split(';')
    .map((r) => r.trim())
    .filter(Boolean);

  return (
    <WbFlag kind="geld" title="Klacht · herbehandeling" className={className}>
      {redenen.length > 0 && <span className="block">Reden: {redenen.join(', ')}</span>}
      <span className="block text-sm">Dit kleed komt terug uit een klacht. Behandel met extra zorg en let op de gemelde punten.</span>
    </WbFlag>
  );
}
